__turbopack_context__.v({
  "latest_news_row": "LatestNewsRow-module-scss-module__2yOugG__latest_news_row",
  "latest_news_row_splide_arrow": "LatestNewsRow-module-scss-module__2yOugG__latest_news_row_splide_arrow",
  "latest_news_row_title": "LatestNewsRow-module-scss-module__2yOugG__latest_news_row_title",
});
